module.exports = __webpack_public_path__ + "img/horizontal_7_4_2.55f72618.png";